import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

import { Button, Typography, FooterBar } from 'components'
import './confirmFactcheckImported.scss'

const ConfirmFactcheckImported = ({ reviewId, show, onClose }) => (
  <FooterBar show={show}>
    <div className="confirm-factcheck-imported">
      <div className="confirm-factcheck-imported--text">
        <Typography color="primary-white" variant="title-1">
          This factcheck has been imported:
        </Typography>
      </div>
      <div className="confirm-factcheck-imported--actions">
        <Button onClick={onClose} variant="ghost-reverse-link">
          <Typography
            className="confirm-factcheck-imported--actions--cancel"
            color="primary-white"
            variant="title-3"
          >
            Close
          </Typography>
        </Button>
        <Link to={`/review/${reviewId}`}>
          <Button type="internalLink" variant="ghost-reverse">
            Go to Review page
          </Button>
        </Link>
      </div>
    </div>
  </FooterBar>
)

ConfirmFactcheckImported.defaultProps = {
  reviewId: null,
  show: false,
}

ConfirmFactcheckImported.propTypes = {
  reviewId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
}

export default ConfirmFactcheckImported
